import React from 'react';
import { Link } from 'gatsby';
import ImageQuote from '../images/ImageQuote';

const BookDiscoveryCall = () => {
  return (
    <div className="col-md-12 mx-auto p-0">
      <div className="card min-vh-80  case-study border-0 rounded-0 text-white">
        <ImageQuote />
        <div className="card-img-overlay min-vh-80 ov">
          <div className="row align-items-center min-vh-80 h-100">
            <div className="card col-md-8 text-center text-md-left mx-auto align-self-center p-md-5 p-2 rounded-0 border-0 bg-transparent">
              <p className="card-text display-4  text-neutralDark">
                Do you need an IT and Digital company that is simple & straightforward ...
              </p>
              <p className="card-text case-text text-neutralDark">
                Get in touch with us so we can help you with your needs
              </p>
              <div className="py-4 px-0">
                <Link to="/contact" className="btn btn-primary btn-lg ml-auto text-center rounded-0 ">
                  Book A Discovery Call &rarr;
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(BookDiscoveryCall);
